import ErrorReader from "../lib/error_reader"
import isEqual from "lodash/isEqual"

const initialState = {
  forApplet: new ErrorReader({}),
  invalidRemoteFields: {},
  missingPreviewAccess: false,
}

export default function errors(state = initialState, event) {
  switch (event.type) {
    default: {
      return state
    }

    case "INVALID_FIELD_RESOLUTION": {
      return {
        ...state,
        invalidRemoteFields: {
          ...state.invalidRemoteFields,
          [event.field.id]: true,
        },
      }
    }

    case "CREATE_OR_UPDATE_APPLET": {
      return {
        ...state,
        forApplet: new ErrorReader({}),
      }
    }

    case "APPLET_CREATE_OR_UPDATE_FAILED": {
      const errors = {}
      const { reason = {} } = event
      const details =
        (reason.message && reason.message.details) || reason.details
      ;(details || []).forEach(error => {
        if (errors[error.parameter]) {
          errors[error.parameter].push(error.message)
        } else {
          errors[error.parameter] = [error.message]
        }
      })

      return {
        ...state,
        forApplet: new ErrorReader(errors),
      }
    }

    case "MISSING_PREVIEW_ACCESS": {
      return { ...state, missingPreviewAccess: true }
    }

    case "INCOMPATIBLE_TRIGGER": {
      return {
        ...state,
        forApplet: new ErrorReader({
          "/applet/applet_actions": [
            `${event.actionService} was removed because it is not compatible with ${event.incompatibleTrigger}.`,
          ],
        }),
      }
    }

    case "CLEAR_INCOMPATIBILITY_ERROR": {
      let errors = { ...state.forApplet.all }

      Object.keys(errors).forEach(key => {
        if (errors[key].some(v => v.includes("compatible"))) {
          delete errors[key]
        }
      })

      if (isEqual(errors, state.forApplet.all)) {
        return state
      } else {
        return {
          ...state,
          forApplet: new ErrorReader(errors),
        }
      }
    }
  }
}
